import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class CalendarEventService {
  static getEvent(id) {
    return HttpUtil.get(API_ROUTES.CALENDAR_EVENT.GET.replace("<id>", id));
  }

  static updateEvent(id, event) {
    return HttpUtil.put(API_ROUTES.CALENDAR_EVENT.UPDATE.replace("<id>", id), event);
  }


  static activateEvent(id, companyId, active) {
    return HttpUtil.patch(API_ROUTES.CALENDAR_EVENT.ACTIVATE
    .replace("<companyId>", companyId)
    .replace("<id>", id)
    .replace("<active>", active), {});
  }

  static getRangeOfEvents(startDate, endDate) {
    return HttpUtil.get(API_ROUTES.CALENDAR_EVENT.GET_EVENTS_RANGE
    .replace("<startDate>", startDate)
    .replace("<endDate>", endDate));
  }

}
